const transformDateToYearMonthDate = (value: string): string => {
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    return '';
  }
};

const getYearFromDate = (value: string): string => {
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    return `${year}`;
  } catch (error) {
    return '';
  }
};

const getYearRange = (from: string, to: string): string => {
  const fromYear = getYearFromDate(from);
  const toYear = getYearFromDate(to);

  return `${fromYear}-${toYear}`;
};

const formatToReadableDate = (dateInput: string): string => {
  const date = new Date(dateInput);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  };

  return date.toLocaleDateString('en-US', options);
};

const timeUtils = {
  transformDateToYearMonthDate,
  getYearFromDate,
  getYearRange,
  formatToReadableDate
};

export default timeUtils;
